/* eslint-disable no-throw-literal */
import LoadingScreen from 'components/LoadingScreen';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

const Dashboard = () => {
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth.tokenChecked && !auth.user.email) {
      window.location.href = `${window.location.origin}`;
    }
  }, [auth.tokenChecked, auth.user.email]);

  return auth.tokenChecked && auth.user.email ? <Outlet /> : <LoadingScreen />;
};

export default Dashboard;
